<div>
  <h5 class="mt-3">
    <span class="mr-2">Existe mais de uma encomenda com o protocolo selecionado </span>
    <mat-icon (click)="fecharSelecaoPedido()">close</mat-icon>
  </h5>
  <span>Favor verificar o destinatário e selecionar a encomenda.</span>
</div>

<mat-nav-list>
  <a *ngFor="let pedido of pedidos" mat-list-item (click)="openLink(pedido, $event)">
    <strong mat-line>{{pedido.desRazaoSocial}}</strong>
    <span mat-line>Documento #{{pedido.pedidoId}} - {{pedido.nomeServico}}</span>
  </a>
</mat-nav-list>